/**
 * Represents the symbol for the RouterService.
 */
export const RouterService = Symbol('RouterService');
